<script setup>
import { useWebSiteStore } from '@/stores/website.store.js'

import SubscriptionForm from '@/components/subscription/SubscriptionForm.vue'
import SubscriptionManage from '@/components/subscription/SubscriptionManage.vue'
import SubscriptionResume from '@/components/subscription/SubscriptionResume.vue'

const webSiteStore = useWebSiteStore()
</script>

<template>
  <div>
    <SubscriptionResume v-if="webSiteStore.isPausedSubscription" />

    <SubscriptionManage v-else-if="webSiteStore.hasActiveSubscription" />

    <SubscriptionForm v-else />
  </div>
</template>
